
import { IconPlus, RevCard, openModal } from '@backmarket/design-system'

import { MODAL_NAMES } from '@config/constants'

import BundleListing from '../BundleListing/BundleListing.vue'
import BundleSmallToModalButton from '../BundleSmallToModalButton/BundleSmallToModalButton.vue'

import BundleModal from './BundleModal/BundleModal.vue'

export default {
  components: {
    BundleListing,
    BundleSmallToModalButton,
    RevCard,
    IconPlus,
    BundleModal,
  },

  props: {
    status: {
      type: String,
      required: true,
    },
    listings: {
      type: Array,
      default: () => [],
    },
    totalPrice: {
      type: String,
      default: null,
    },
  },

  methods: {
    openBundleModal() {
      openModal(MODAL_NAMES.PRODUCT.BUNDLE)
    },
    addToCart() {
      this.$emit('add-to-cart')
    },
  },
}
